/**
 * Homepage selectors
 */

import { createSelector } from 'reselect';

const selectNyheter = state => state.get('nyheter');
const makeSelectListView = () =>
  createSelector(
    selectNyheter,
    EvenemangState => EvenemangState.get('listview'),
  );
const makeSelectMasonryView = () =>
  createSelector(
    selectNyheter,
    EvenemangState => EvenemangState.get('masonryview'),
  );

const getPage = () =>
  createSelector(
    selectNyheter,
    EvenemangState => EvenemangState.get('page'),
  );
const getPageSize = () =>
  createSelector(
    selectNyheter,
    EvenemangState => EvenemangState.get('pagesize'),
  );

const getMore = () =>
  createSelector(
    selectNyheter,
    EvenemangState => EvenemangState.get('more'),
  );

export {
  selectNyheter,
  getPage,
  getPageSize,
  makeSelectMasonryView,
  makeSelectListView,
  getMore,
};
